import {ILock, ILockClassSummaryCollection, ILockCollection, ILockObject, ILockOptions} from "./PA.Concurrency.IF.Lock";
import * as AGChannel from "ag-channel"

export interface IServerClassObjectNode {
    ClassId: string,
    LockId: number | string,

    Object_IDUI: string,
    Object_Name: string,

    OwnerLockKey?: string,
    OwnerLockTime?: string,

    StatusOnlyLockKey?: string,
    LockKeys: {[id:string]: string}
}


export interface IServerLock {
    LockKey: string,
    ClassId: string,
    LockId: number | string,

    StatusOnly: string,

    SessionId: string,
    OwnerName: string,
    HostName: string,

    CreatorId?: string
    CreationTS: string,
    LastAccessTS: string
    ExpiresOnTS: string
}


export enum IServerLockChannelMessageType {
    ClassUpdate = "ClassUpdate",
    LockUpdate = "LockUpdate",
    Destroy = "Destroy"
}

export interface IServerLockChannelMessage {
    MessageType: IServerLockChannelMessageType,
    MessageSequenceId: number,
    ClassId?: string,
    LockId?: number | string,
    LockKey?: string,
    Lock?: IServerLock
    OwnerLock?: IServerLock,
    Object?: ILockObject
}

export interface IServerLockOptions extends ILockOptions {
    SessionId?: string,
    OwnerName?: string,
    HostName?: string,
    CreatorId?: string,
}

export interface IServerLockAcquireReleaseResponse {
    bSuccess: boolean,
    sFailureReason?: string,
    Lock: IServerLock
}


export interface ILockServiceInternal {
    getLockMessageChannel(classId: string, lockId: number | string): Promise<AGChannel<IServerLockChannelMessage>>
    createServerLock(classId: string, lockId: number| string , options?: ILockOptions): Promise<string>
    createServerLocks(classId: string, arrLockId: (number| string), options?: ILockOptions): Promise<string[]>
    acquireServerLock(lockKey: string, iTimeout?: number): Promise<IServerLockAcquireReleaseResponse>
    releaseServerLock(lockKey: string, iTimeout?: number): Promise<IServerLockAcquireReleaseResponse>
    touchServerLock(lockKey: string, iTimeout?: number): Promise<void>
    destroyServerLock(lockKey: string, iTimeout?: number): Promise<void>

   // breakServerLock(classId: string, lockId: number| string):Promise<IServerLockAcquireReleaseResponse>
}

export interface ILockServiceAdminClient {

   breakLock(classId: string, lockId: number| string ): Promise<IServerLockAcquireReleaseResponse>

}

export interface ILockAdminServiceInternal {
    breakServerLock(classId: string, lockId: number| string):Promise<IServerLockAcquireReleaseResponse>
}
